import React from 'react';
import styled from 'styled-components';
import { Nav } from '@catalogo/core-nav';
import AccessbilityIcon from '@catalogo/ui-americanas-desktop-svg/icon-handtalk.svg';
import FacebookIcon from '@catalogo/ui-americanas-desktop-svg/icon-social-facebook.svg';
import TwitterIcon from '@catalogo/ui-americanas-desktop-svg/icon-social-twitter.svg';
import InstagramIcon from '@catalogo/ui-americanas-desktop-svg/icon-social-instagram.svg';
import YoutubeIcon from '@catalogo/ui-americanas-desktop-svg/icon-social-youtube.svg';
import TiktokIcon from '@catalogo/ui-americanas-desktop-svg/icon-social-tiktok.svg';

export const Social = ({ loadHandTalkScript, hotsite }) => (
  <Container>
    <AccessbilityContainer>
      <AccessbilityLink onClick={loadHandTalkScript}>
        <AccessbilityIconStyled height="25px" />
        tradutor para Libras
      </AccessbilityLink>
      <KnowMoreLink to={hotsite}>acessibilidade digital na Americanas</KnowMoreLink>
    </AccessbilityContainer>
    <SocialContainer>
      <SocialIcon>
        <SocialLink to="https://www.youtube.com/CanalAmericanas" target="_blank">
          <YoutubeIcon fill="#999" width="20px" height="20px" />
        </SocialLink>
      </SocialIcon>
      <SocialIcon>
        <SocialLink to="https://www.facebook.com/americanas" target="_blank">
          <FacebookIcon fill="#999" width="20px" height="20px" />
        </SocialLink>
      </SocialIcon>
      <SocialIcon>
        <SocialLink to="https://www.instagram.com/americanas" target="_blank">
          <InstagramIcon fill="#999" width="20px" height="20px" />
        </SocialLink>
      </SocialIcon>
      <SocialIcon>
        <SocialLink to="https://twitter.com/americanas" target="_blank">
          <TwitterIcon fill="#999" width="20px" height="20px" />
        </SocialLink>
      </SocialIcon>
      <SocialIcon>
        <SocialLink to="https://www.tiktok.com/@americanas" target="_blank">
          <TiktokIcon fill="#999" width="20px" height="20px" />
        </SocialLink>
      </SocialIcon>
    </SocialContainer>
  </Container>
);

const AccessbilityContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0.5em 1em 1em;
`;

const AccessbilityIconStyled = styled(AccessbilityIcon)`
  margin-right: 5px;
`;

const KnowMoreLink = styled(Nav)`
  text-align: center;
  text-decoration: underline;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: color 0.3s;
  margin-bottom: 32px;

  &:hover,
  &:active {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const AccessbilityLink = styled(Nav)`
  display: flex;
  border: 1px solid #666;
  border-radius: 4px;
  padding: 6px;
  margin: 0 auto 25px;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;
  max-width: 184px;
  font-size: 14px;
  font-weight: bold;

  &:hover,
  &:active {
    background-color: #e1e1e1;
  }
`;

const SocialIcon = styled.li`
  display: inline-block;
`;

const SocialContainer = styled.ul`
  text-align: center;
  margin: 0 auto;
  padding-bottom: 20px;
`;

const SocialLink = styled(Nav)`
  width: 25px;
  height: 25px;
  padding: 0.3em 0.5em;
`;

const Container = styled.div`
  padding: 20px 0;
  background: #eaeaea;
`;

export default Social;
